export const GET_QUESTIONS_SUCCESS = 'QUESTIONS_SUCCESS';
export const QUESTIONS_ERROR = 'QUESTIONS_ERROR';
export const SHOW_LOADER = 'SHOW_LOADER';